import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import FilterContainer from '../../containers/Insights/FilterContainer';
import CardListContainer from '../../containers/Insights/CardListContainer';
import {
  fetchInsightSettings,
  getVrrPreferences
} from '../../redux/settings/settingAction';

const InsightsPage: React.FC = () => {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();
  const brandId = useSelector(getVrrPreferences)?.current_brand_id;

  useEffect(() => {
    if (brandId) {
      dispatch(fetchInsightSettings());
    }
  }, [brandId]);

  return (
    <>
      <div className="insights-video-page">
        <h4>{t('pages.insights.title').toUpperCase()}</h4>
      </div>
      <FilterContainer />
      <CardListContainer />
    </>
  );
};

export default InsightsPage;
